import { WorkloadType } from '@/components/Workload/types';
import { useTranslation } from 'react-i18next';

const { DEPLOYMENT, STATEFULSET, DAEMONSET } = WorkloadType;
export const useWorkloadName = (workload: WorkloadType) => {
  const { t } = useTranslation();
  let typeName = '';

  switch (workload) {
    case DEPLOYMENT:
      typeName = t('common:deployment');
      break;
    case STATEFULSET:
      typeName = t('common:statefulset');
      break;
    case DAEMONSET:
      typeName = t('common:daemonset');
      break;
    default:
      break;
  }

  return { workloadName: typeName };
};
